
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import { checkboxContainer } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["id", "label", "size", "required", "inline", "containerAttrs", "isPartiallySelected", "readOnly"];
var Checkbox = function Checkbox(props, ref) {
  var id = props.id,
    label = props.label,
    _props$size = props.size,
    size = _props$size === void 0 ? "md" : _props$size,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$inline = props.inline,
    inline = _props$inline === void 0 ? false : _props$inline,
    containerAttrs = props.containerAttrs,
    isPartiallySelected = props.isPartiallySelected,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    rest = _objectWithoutProperties(props, _excluded);
  return jsx("div", _extends({
    ref: ref,
    css: function css(theme) {
      return checkboxContainer(theme, {
        size: size,
        inline: inline,
        readOnly: readOnly
      });
    }
  }, containerAttrs), isPartiallySelected && jsx("span", {
    "data-testid": "is-partially-selected",
    className: "dash"
  }), jsx("input", _extends({
    id: id,
    type: "checkbox",
    readOnly: readOnly
  }, rest)), jsx("label", {
    htmlFor: id,
    "data-testid": "checkbox-label-".concat(id)
  }, jsx("span", {
    className: "shadow-element",
    tabIndex: -1,
    "aria-hidden": "true"
  }), label, required && jsx("span", {
    className: "required"
  })));
};
var Checkbox$1 = /*#__PURE__*/forwardRef(Checkbox);

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
